// Arabic case studies for /ar/work. Slugs match English pairs.

export const WORK_INTRO_AR =
  "خمسة مشاريع، موثّقة بشكل صحيح. ما كان معطلًا سابقًا، ما بنيناه، أي الأجزاء كانت صعبة فعليًا، وما تغيّر بعد الإطلاق. حيث كنا سنفعل شيئًا مختلفًا في المرة الثانية، نقول ذلك.";

// The five case studies mirror the English /work catalogue. `thumbnailId`
// reuses the same image assets — image copy is identical, only alt text
// changes to Arabic on the AR side.
export const WORK_AR = {
  "delivery-logistics-platform": {
    slug: "delivery-logistics-platform",
    navLabel: "منصة التوصيل والخدمات اللوجستية",
    eyebrow: "دراسة حالة",
    h1: "منصة التوصيل والخدمات اللوجستية",
    status: "لوجستيات · عُمان · جاهز للإطلاق",
    statusKind: "building",
    thumbnailId: "cs-delivery-hero",
    meta: { title: "دراسة حالة — منصة التوصيل والخدمات اللوجستية في عُمان", description: "أربعة تطبيقات على خلفية واحدة — تطبيق عملاء، تطبيق سائق، لوحة إدارة، وبوابة شاحنين — مبنية للإطلاق في عُمان." },
    intro: "أربعة تطبيقات على خلفية واحدة بالإضافة إلى واجهة برمجية عامة — تطبيق عملاء، تطبيق سائق، لوحة تحكم إدارية، وبوابة أعمال للشاحنين.",
    sections: [
      { type: "block", heading: "المشكلة التي انطلقنا لحلها", paragraphs: [
        "التوصيل في عُمان ما زال يعمل عبر المكالمات الهاتفية والورق — سائقون يُكلَّفون عبر واتساب، عملاء يتصلون للسؤال عن مكان طردهم، إثبات تسليم على إيصال يُفقد، وعملاء أعمال بأسعار متفق عليها مختلفة تعيش في ذاكرة أحدهم.",
      ] },
      { type: "grid", heading: "ما نبنيه", items: [
        { title: "تطبيق العملاء", desc: "حجز متعدد الخدمات، محفظة، وتتبع." },
        { title: "تطبيق السائق", desc: "عروض، GPS، وإثبات تسليم بثلاث خطوات." },
        { title: "لوحة الإدارة", desc: "التوزيع، الوكلاء، والحسابات." },
        { title: "بوابة الشاحنين", desc: "B2B، بطاقات أسعار لكل عميل." },
        { title: "واجهة برمجية للطلبات", desc: "مواجهة الشركاء." },
        { title: "تصدير الحسابات", desc: "Excel، لكل عميل وفترة." },
      ] },
      { type: "block", heading: "الأجزاء الصعبة",
        bullets: [
          "التوزيع الآلي — العروض تتتالى للسائق الأقرب المتاح بمهلة زمنية، تتصاعد للخارج، وتعود للتكليف اليدوي عند الحاجة، مع تجمعات سائقين منفصلة تمامًا لأنواع التوصيل المتخصصة.",
          "التسعير — أربع طرق، بطاقات أسعار لكل شاحن مع احتياطي، ومحرك عمولة سائقين تحته.",
          "إثبات التسليم — الاسم، الصورة، والتوقيع إلزامية جميعًا، مع ضغط الصور على الجهاز لتُرفع رغم ضعف بيانات الجوال.",
          "بوالص الشحن — باركود ورمز استجابة سريع، PDF بحجم A6، طباعة دفعية، بعلامة بيضاء لكل شاحن.",
        ],
      },
      { type: "stack", heading: "الحزمة التقنية", items: ["React Native / Expo", "FastAPI", "React", "MongoDB Atlas", "Google Places"] },
      { type: "block", heading: "ما سيتغيّر مع الإطلاق",
        bullets: [
          "نقل التوزيع من واتساب إلى محرك تكليف آلي بعروض متتالية وتراجع",
          "إعطاء عملاء الأعمال بوابة خدمة ذاتية بأسعارهم المتفق عليها مبنية داخلها",
          "إعطاء العملاء تتبعًا مباشرًا وأوقات وصول متوقعة بدلًا من المكالمات الهاتفية",
        ],
      },
    ],
    related: [
      { tag: "الحلول", label: "منصة التوصيل عند الطلب", to: "/ar/solutions/on-demand-delivery-platform" },
      { tag: "الصناعات", label: "الخدمات اللوجستية والنقل", to: "/ar/industries/logistics-software-development-oman" },
      { tag: "الخدمات", label: "تطوير تطبيقات الجوال", to: "/ar/services/mobile-app-development-company-in-oman" },
    ],
  },
  "warehouse-management-system": {
    slug: "warehouse-management-system",
    navLabel: "نظام إدارة المستودعات",
    eyebrow: "دراسة حالة",
    h1: "نظام إدارة المستودعات",
    status: "التخزين · آسيا والولايات المتحدة · تم التسليم",
    statusKind: "delivered",
    thumbnailId: "cs-wms",
    meta: { title: "دراسة حالة — إدارة المستودعات", description: "دقة على مستوى الصندوق، انتقاء عبر الهاتف، وتسوية ليلية — سُلّم لمشغّلين في سنغافورة وماليزيا والولايات المتحدة." },
    intro: "نظام إدارة مستودعات كامل سُلّم لمشغّلي لوجستيات طرف ثالث في سنغافورة وماليزيا والولايات المتحدة — الاستلام، التخزين، الانتقاء، التعبئة، الإرسال، وجرد المخزون.",
    sections: [
      { type: "block", heading: "المشكلة", paragraphs: [
        "مشغّلو المستودعات يديرون المخزون عبر جداول بيانات، دون صورة فعلية بالوقت الحقيقي لما هو موجود وأين.",
      ] },
      { type: "block", heading: "ما بنيناه", paragraphs: [
        "نظام إدارة مستودعات يغطي الاستلام، التخزين، إدارة المواقع، الانتقاء، الإرسال، ودقة المخزون.",
      ] },
      { type: "callout", text: "الحالة: تم بناؤه وتسليمه لمشغّلين في سنغافورة وماليزيا والولايات المتحدة." },
    ],
    related: [
      { tag: "الحلول", label: "إدارة المستودعات", to: "/ar/solutions/warehouse-management" },
      { tag: "الصناعات", label: "الصناعة والتوزيع", to: "/ar/industries/manufacturing-software-development-oman" },
      { tag: "الخدمات", label: "برمجيات المؤسسات", to: "/ar/services/enterprise-software-development-company-in-oman" },
    ],
  },
  "logistics-erp": {
    slug: "logistics-erp",
    navLabel: "نظام ERP اللوجستي",
    eyebrow: "دراسة حالة",
    h1: "نظام ERP اللوجستي",
    status: "ERP لوجستي · أريزونا، الولايات المتحدة · تم التسليم",
    statusKind: "delivered",
    thumbnailId: "cs-erp",
    meta: { title: "دراسة حالة — نظام ERP اللوجستي (أريزونا، الولايات المتحدة)", description: "المالية، العمليات، والتوزيع مترابطة لمشغّل لوجستي في الولايات المتحدة." },
    intro: "المالية، العمليات، والتوزيع مترابطة لمشغّل لوجستي في الولايات المتحدة، سُلّم من عُمان مع فريق مقابل داخل الدولة.",
    sections: [
      { type: "block", heading: "المشكلة", paragraphs: [
        "مشغّل لوجستي يدير المالية والعمليات عبر أنظمة منفصلة لا تتواصل.",
      ] },
      { type: "block", heading: "ما بنيناه", paragraphs: [
        "نظام ERP لوجستي كامل يربط العمليات بالمالية.",
      ] },
      { type: "callout", text: "الحالة: تم بناؤه وتسليمه لعميل في أريزونا، الولايات المتحدة." },
    ],
    related: [
      { tag: "الخدمات", label: "ERP و HRMS", to: "/ar/services/erp-software-development-company-in-oman" },
      { tag: "الخدمات", label: "برمجيات المؤسسات", to: "/ar/services/enterprise-software-development-company-in-oman" },
      { tag: "الحلول", label: "برمجيات اللوجستيات وإدارة الأسطول", to: "/ar/solutions/logistics-fleet-software" },
    ],
  },
  "showroom-management-platform": {
    slug: "showroom-management-platform",
    navLabel: "منصة إدارة المعارض",
    eyebrow: "دراسة حالة",
    h1: "منصة إدارة معارض السيارات",
    status: "السيارات · مسقط · مباشر",
    statusKind: "live",
    thumbnailId: "cs-showroom",
    meta: { title: "دراسة حالة — منصة إدارة المعارض (مسقط)", description: "مخزون المركبات، المبيعات، العملاء المحتملون، المستندات، وموقع قوائم عام. مباشر في مسقط." },
    intro: "مخزون المركبات بما فيه الأمانة، المبيعات، العملاء المحتملون، الحجوزات، المدفوعات، المستندات، النماذج القابلة للطباعة، التقارير، وموقع قوائم عام.",
    sections: [
      { type: "block", heading: "المشكلة", paragraphs: [
        "معارض السيارات تتبع المخزون عبر جداول بيانات، والسيارات بالأمانة على الورق، والعملاء المحتملون في مجموعة واتساب.",
      ] },
      { type: "block", heading: "ما بنيناه", paragraphs: [
        "منصة كاملة لإدارة المعارض — مخزون مملوك وبأمانة، المبيعات، العملاء المحتملون، الحجوزات، المدفوعات والحسابات، إدارة المستندات، لوحات تحكم وتقارير — بالإضافة إلى موقع عام يعرض السيارات، وثلاثة نماذج قابلة للطباعة يستخدمها المعرض يوميًا: تفويض بيع، إفراج فحص، وتجربة قيادة.",
      ] },
      { type: "callout", text: "الحالة: مباشر في مسقط، ويُرخَّص الآن لمعارض إضافية." },
    ],
    related: [
      { tag: "الحلول", label: "إدارة المعارض", to: "/ar/solutions/showroom-management" },
      { tag: "الصناعات", label: "السيارات", to: "/ar/industries/automotive-software-development-oman" },
      { tag: "الخدمات", label: "تطوير CRM", to: "/ar/services/crm-software-development-company-in-oman" },
    ],
  },
  "marketplace-commerce": {
    slug: "marketplace-commerce",
    navLabel: "تجارة السوق الإلكتروني",
    eyebrow: "دراسة حالة",
    h1: "تجارة السوق الإلكتروني",
    status: "التجارة الإلكترونية · قيد التطوير",
    statusKind: "building",
    thumbnailId: "cs-marketplace",
    meta: { title: "دراسة حالة — تجارة السوق الإلكتروني", description: "تجارة متعددة البائعين مع تقسيم الطلبات، العمولات، والتحويلات." },
    intro: "سوق إلكتروني متعدد البائعين قيد التطوير لعُمان ومنطقة الخليج — تسجيل البائعين، الكتالوج، العمولات، الطلبات المُقسَّمة، والتحويلات، مصمم للعمل جنبًا إلى جنب مع منصتنا للتوصيل.",
    sections: [
      { type: "block", heading: "المشكلة", paragraphs: [
        "بناء سوق إلكتروني لعُمان ومنطقة الخليج من الصفر، بما في ذلك الهوية التجارية.",
      ] },
      { type: "block", heading: "ما بنيناه", bullets: [
        "منصة سوق إلكتروني وتطبيق، تُسجّل البائعين، تحتوي الكتالوج، محرك العمولة، وتقسيم الطلبات",
        "نظام هوية تجارية كامل يغطي أيقونة التطبيق، أدوات التواصل الاجتماعي، القرطاسية، الفواتير، وتغليف التوصيل",
      ] },
      { type: "callout", text: "الحالة: قيد التطوير للسوق العُماني ومنطقة الخليج." },
    ],
    related: [
      { tag: "الحلول", label: "منصة السوق الإلكتروني", to: "/ar/solutions/e-commerce-marketplace" },
      { tag: "الصناعات", label: "التجزئة والتجارة الإلكترونية", to: "/ar/industries/ecommerce-software-development-oman" },
      { tag: "الحلول", label: "إدارة المستودعات", to: "/ar/solutions/warehouse-management" },
    ],
  },
};

export const WORK_LIST_AR = Object.values(WORK_AR);
